import styled from 'styled-components';
import FacebookLogo from '@/assets/icon/logo_facebook.svg';
import InstaLogo from '@/assets/icon/logo_instagram.svg';
import YoutubeLogo from '@/assets/icon/logo_youtube.svg';
import { useContactProfile } from '@/hooks/useSiteProfile';

const SOCIAL_LINKS = [
  {
    id: 'instagramUrl',
    label: '제주로렌트카 인스타그램',
    icon: InstaLogo,
  },
  {
    id: 'facebookUrl',
    label: '제주로렌트카 페이스북',
    icon: FacebookLogo,
  },
  {
    id: 'youtubeUrl',
    label: '제주로렌트카 유튜브',
    icon: YoutubeLogo,
  },
] as const;

const SocialLinks = ({ isMobile }: { isMobile?: boolean }) => {
  const contact = useContactProfile();
  const links = SOCIAL_LINKS.filter((item) => contact[item.id]);
  if (!links.length) return null;
  return (
    <Wrapper isMobile={isMobile}>
      {links.map((item) => (
        <IconLink
          key={item.id}
          href={contact[item.id]}
          target='_blank'
          rel='noopener noreferrer'
          aria-label={item.label}
        >
          <img src={item.icon} width={36} height={36} alt={item.label} />
        </IconLink>
      ))}
    </Wrapper>
  );
};

export default SocialLinks;

const Wrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: ${({ isMobile }) => (isMobile ? '24px' : '20px')};
`;

const IconLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`;
